import { useEffect, useState } from "react";
import { createConversionJourney, type ConversionStep } from "../utils/conversionJourney";
import { trackLogfrogEvent } from "../utils/logfrog";

export function useConversionJourney(step: ConversionStep | null, mode: "setup" | "upgrade" | "onboarding" = "setup") {
  const [journey] = useState(() => createConversionJourney(trackLogfrogEvent, { platform: "web", mode }));
  useEffect(() => { journey.setContext({ mode }); journey.view(step); }, [journey, step, mode]);
  return journey;
}
